import { render, staticRenderFns } from "./uf_is_grant_been_development.vue?vue&type=template&id=29e39ded&scoped=true"
import script from "./uf_is_grant_been_development.vue?vue&type=script&lang=js"
export * from "./uf_is_grant_been_development.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e39ded",
  null
  
)

export default component.exports